import intlTelInput from 'intl-tel-input';

let Hooks = {}

Hooks.TelInput = {
    mounted() {
        intlTelInput(this.el, {
            initialCountry: this.el.dataset.country,
            preferredCountries: ["us", "za", "de", "gb", "cz", "ro"],
            nationalMode: false
        });
    }
}

export {Hooks}